import { Typography, Box, Avatar, IconButton } from "@mui/material";
import React from "react";
import moment from "moment";
import DeleteIcon from "@mui/icons-material/Delete";

const CommentComponent = ({ comment, setOpenDelete, deleteSelected }) => {
  return (
    <>
      <Box className="action-wrapper">
        <Box className="comment-wrapper">
          <Box className="user-details">
            <Avatar
              alt="Remy Sharp"
              src={comment.commentUserDetails?.profile_img}
              sx={{ width: 24, height: 24 }}
            />
            <Box sx={{ display: "flex", gap: "10px" }}>
              <Typography component="p">
                {comment.commentUserDetails?.firstname +
                  " " +
                  comment.commentUserDetails?.lastName}
              </Typography>
              <Typography component="span">
                {moment(comment?.createdAt).format("MMM D,YYYY h:mm a")}
              </Typography>
            </Box>
          </Box>
          <Box className="comment-text">{comment.comment_text}</Box>
        </Box>
        <IconButton
          sx={{ alignSelf: "baseline" }}
          onClick={() => {
            deleteSelected.current = comment;
            setOpenDelete(true);
          }}
        >
          <DeleteIcon />
        </IconButton>
      </Box>
      {/* {comment?.commentReplies?.length > 0 && } */}
    </>
  );
};

export default CommentComponent;
